import React from "react";

const CartItemSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-[1fr_150px_150px_150px] py-4 max-md:border max-md:border-lightBlue max-md:rounded-lg max-md:p-3 max-md:grid-cols-1 relative max-md:my-4">
      <div className="flex items-center gap-1">
        <div className="skeleton w-28 max-md:w-14 h-44 max-md:h-[88px] max-md:!rounded-md"></div>
        <div className="max-md:w-full">
          <div className="flex items-center mb-2 gap-3">
            <span className="skeleton w-5 h-5"></span>
            <h4 className="skeleton w-48 h-7 max-md:h-6 max-md:!rounded-md text-2xl text-primary line-clamp-3 text-left break-words max-md:text-base break-all"></h4>
          </div>

          <span className="skeleton w-20 h-7 max-md:h-6 max-md:!rounded-md ml-1 text-lg text-primary text-start block"></span>

          <button
            className="skeleton w-16 max-md:w-6 h-6 max-md:!rounded-md mt-3 ml-2 flex items-center gap-1 text-lg text-secondary duration-150 hover:scale-95 max-md:absolute max-md:top-2 max-md:right-2"
            aria-label="remove"
          ></button>

          <div className="flex items-center justify-between mt-2 md:hidden">
            <span className="text-primary text-2xl md:hidden max-md:text-base skeleton w-20 h-5 max-md:!rounded-md"></span>
            <div className="inline-flex justify-center items-center text-xl text-primary gap-5">
              <button
                className="disabled:hover:cursor-not-allowed"
                aria-label="minus"
              >
                -
              </button>
              <span className="text-center skeleton w-5 h-5 max-md:!rounded-md"></span>
              <button aria-label="plus">+</button>
            </div>
          </div>
        </div>
      </div>
      <div className="inline-flex justify-center items-center text-xl text-primary gap-5 max-md:hidden">
        <button aria-label="minus">-</button>
        <span className="text-center skeleton w-6 h-6 !rounded-md"></span>
        <button aria-label="plus">+</button>
      </div>
      <div className="flex items-center justify-center max-md:hidden">
        <span className="text-primary text-2xl skeleton w-20 h-6 !rounded-md"></span>
      </div>
      <div className="flex items-center justify-center max-md:hidden">
        <span className="text-primary text-2xl skeleton w-20 h-6 !rounded-md"></span>
      </div>
    </div>
  );
};

export default CartItemSkeleton;
